// extracted by mini-css-extract-plugin
module.exports = {"container":"i_o","wrapper":"i_p","label":"i_q","title":"i_r","subtitle":"i_s","icon":"i_t","left-image":"i_u","left-icon":"i_v"};